import React, { ReactNode, useEffect } from 'react';
import cx from 'classnames';
import { ArrowUp } from '../../../../assets/icons/arrowUp';
import { ArrowDown } from '../../../../assets/icons/arrowDown';
import Empty from './Empty';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

interface Transaction {
  id: string; 
  createdAt: number;
  amount: number;
  customer: {
    firstName: string;
    lastName: string;
  };
  vendorName: string; 
  type:string;
}

interface TransactionTableProps {
  bgColorClass: string;
  data: Transaction[];
  type: string;
  recentCount: number;
}

const TransactionInfo = ({ isLoading, error, transactions, type }: any) => {
  const recentCount = 4;
  return (
    <div className={` bg-white h-[289px] md:h-[318px] lg:py-[em] xl:flex-1 ${transactions.length < 5 }`}>
      <h3 className="text-[15px] font-semibold py-[1em] mt-[1em] px-[1em] lg:px-0 xl:px-0 2xl:px-0 sm:ml-[2em] md:py-[1em] md:text-[18px] xl:mb-2 lg:mt-[1px] lg:py-[em] xl:mt-[1px]  xl:py-[em] xl:ml-[2em] xl:text-[#2E2E2E] xl:text-[20px] xl:font-semibold xl:leading-5">
        Recent Transaction
      </h3> 
      {isLoading ? (
        <p>Loading transactions...</p>
      ) : (
        <TransactionCard data={transactions} bgColorClass="bg-green-200" type={type} recentCount={recentCount} />
      )}
      {(transactions.length === 0) && !isLoading && (<Empty />)}
    </div>
  );
};

 export { TransactionInfo };

const TransactionCard: React.FC<TransactionTableProps> = ({ bgColorClass, data, type, recentCount }) => {
  const bgClassName = (bgColorClass: string) => {
    return cx('w-6 h-6 lg:w-9  lg:h-9 flex rounded-full justify-center items-center', {
      ["bg-green-200"]: bgColorClass === "invoice",
      ["bg-red-100"]: bgColorClass === "expense",
    });
  };

  
  const recentTransactions = data
  .sort((a, b) => b.createdAt - a.createdAt)
  .slice(-recentCount)
  .reverse();


  function addOrdinalSuffix(day: number): string {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const relevantDigits = (day / 10) % 10 === 1 ? 0 : day % 10;
    const suffix = suffixes[relevantDigits] || suffixes[0];
    return `${day}${suffix}`;
  }
  return (
    <div className='items-center flex-col top-0 left-0 lg:py-[1em] lg:px-[10px]'>
      {recentTransactions.map(({ data }: any, i) => {
      const { id, createdAt, amount, customer, vendorName, type, balanceDue } = data;
        const isInvoice = type === 'invoice';
        const rowClassName = cx('flex lg:justify-between justify-between pr-[1em] pb-[1em] whitespace-normal biglg:justify-between xl:justify-between  hover:bg-gray-200 rounded-lg pl-[1em] xl:pr-[2em] lg:whitespace-nowrap overflow-hidden overflow-ellipsis  ');

        return (
          <div className={rowClassName} key={id}>
                     <div className="h-[70px] flex items-center  gap-[19px]">
            <div className="flex flex-col justify-center gap-[2px]">
              <p className={bgClassName(data.type)}>
                {data.type === 'invoice' ? <ArrowUp /> : <ArrowDown />}
              </p>
            </div>
            <div className=" flex flex-col  ">
              <div className="hover:bg-gray-200 rounded-md ">
                <h3 className="text-[15px] md:text-[18px] font-semibold flex pb-0 flex-wrap text-[#2E2E2E] xl:text-[20px] xl:flex-wrap xl:font-semibold xl:text-[#2E2E2E] xl:leading-5 lg:pb-1 " > 
                  {data.type === 'invoice' ? (
                    <Link to={`/${data.type}s/${id}/view`}>
                      {customer.firstName} {customer.lastName}
                    </Link>
                  ) : (
                    <Link to={`/${data.type}s/${id}/view`}>{vendorName}</Link>
                  )}
                </h3>
                <span className=" text-[12px] text-[#869296] font-semibold xl:text-[16px] xl:text-[#869296] xl:font-semibold xl:leading-5 lg:pb-5  pb-0">
                  {dayjs(createdAt).format('MMMM')}{' '}
                  {addOrdinalSuffix(dayjs(createdAt).date())},{' '}
                  {dayjs(createdAt).format('YYYY')}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-[4px] biglg:justify-end biglg:pr-[2em] lg:justify-end ">
          <h3 className=" text-[13px] md:text-[15px] md:ml-[10em] ml-[em] mt-[-2em]  lg:ml-[-10em]   xl:ml-[6em] xl:text-[20px] font-semibold leading-5">
              {`₦${
                isInvoice ? (balanceDue !== undefined ? balanceDue.toLocaleString() : '') : (amount !== undefined ? amount.toLocaleString() : '')
              }`}
            </h3>
          </div>
        </div>
      );
    })}
  </div>
);
};

export { TransactionCard };